"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var eventemitter3_1 = require("eventemitter3");
var VidiEmitter = (function (_super) {
    __extends(VidiEmitter, _super);
    function VidiEmitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return VidiEmitter;
}(eventemitter3_1.EventEmitter));
exports.VidiEmitter = VidiEmitter;
//# sourceMappingURL=events.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vidi/dist/src/types/events.js
// module id = 1519
// module chunks = 0 1 2 3